module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-44.8743c02b.png";